angular
  .module('pb.base')

  .directive('trendLabel', function() {
    return {
      restrict: 'E',
      replace: true,
      require: '^ngModel',
      template: `<div>
          <i ng-show="value > 0" class="zmdi zmdi-hc-fw zmdi-long-arrow-up c-green"></i>
          <i ng-show="value == 0" class="zmdi zmdi-hc-fw zmdi-long-arrow-right c-green"></i>
          <i ng-show="value < 0" class="zmdi zmdi-hc-fw zmdi-long-arrow-down c-red"></i>
        </div>`,
      scope: {
        value: '<'
      }
    };
  });
